import React from "react";
import { Icon } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import DashboardLayout from "components/Layouts/DashboardLayout";

export default () => {
	const { t } = useTranslation();

	return (
		<DashboardLayout>
			<div className="mt-5 text-muted" style={{ textAlign: "center" }}>
				<Icon type="file-excel" weight="d" className="fa-4x mb-4" />
				<p className="lead">{t("alerts.permissionError")}</p>
				<Link to="/tasks/my-tasks">
					{t("main.tasks.text.backToTasks")}
				</Link>
			</div>
		</DashboardLayout>
	);
};
